const API_BASE = '/api/v1/auth';

export interface AuthUser {
  id: string;
  email: string;
  name: string | null;
  role: 'ADMIN' | 'MEMBER';
  createdAt: string;
}

export interface AuthResponse {
  success: boolean;
  user?: AuthUser;
  forcePasswordChange?: boolean;
  pendingApproval?: boolean;
  requiresEmailVerification?: boolean;
  message?: string;
  error?: string;
  code?: string;
}

export interface RegisterInput {
  email: string;
  password: string;
  name: string;
}

export interface LoginInput {
  email: string;
  password: string;
}

async function handleResponse<T>(response: Response): Promise<T> {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Errore sconosciuto');
  }
  return data;
}

export async function register(input: RegisterInput): Promise<AuthResponse> {
  const response = await fetch(`${API_BASE}/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(input),
  });
  return handleResponse<AuthResponse>(response);
}

export async function login(input: LoginInput): Promise<AuthResponse> {
  const response = await fetch(`${API_BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(input),
  });
  return handleResponse<AuthResponse>(response);
}

export async function logout(): Promise<{ success: boolean }> {
  const response = await fetch(`${API_BASE}/logout`, {
    method: 'POST',
    credentials: 'include',
  });
  return handleResponse<{ success: boolean }>(response);
}

export async function getMe(): Promise<AuthResponse> {
  const response = await fetch(`${API_BASE}/me`, {
    credentials: 'include',
  });
  return handleResponse<AuthResponse>(response);
}

export async function changePassword(
  currentPassword: string,
  newPassword: string
): Promise<{ success: boolean; message?: string; error?: string }> {
  const response = await fetch(`${API_BASE}/change-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  return handleResponse<{ success: boolean; message?: string; error?: string }>(
    response
  );
}

export async function getUsers(): Promise<{ success: boolean; users?: AuthUser[] }> {
  const response = await fetch(`${API_BASE}/users`, {
    credentials: 'include',
  });
  return handleResponse<{ success: boolean; users?: AuthUser[] }>(response);
}
